/**
 * Canonical external URLs for editorial links on colorscales.io
 */
export const FIGMA_PLUGIN_URL =
  'https://www.figma.com/community/plugin/1564367214330636618/color-scales-i-o';

export const EXTERNAL_LINKS = {
  figmaPlugin: FIGMA_PLUGIN_URL,
  leonardo: 'https://leonardocolor.io/',
  colorNameApi: 'https://api.color.pizza/v1/docs/',
  /** W3C — normative WCAG 2.1 contrast guidance (pairs with APCA tool link below) */
  wcag21Contrast:
    'https://www.w3.org/WAI/WCAG21/Understanding/contrast-minimum',
  /** APCA calculator (Myndex); public tool for WCAG 3 contrast — not hosted on w3.org */
  apca: 'https://apcacontrast.com/',
} as const;
